import L1InputLabel from '../l1/L1InputLabel'
import { useFormSelector } from '../../../redux/formStoreHooks'
import { selectExport } from '../../../redux/selectForm'
import { useConceptStatus } from '../../../redux/selectConceptStatus2'
import { CollaboratingPhysicianSignatureNameConcept, getConceptStatusValue } from '@fusion-advantage/formlib'

interface L4SignatureNameProps {
	party: 'patient'|'evaluator'|'collaborator'
}

const L4SignatureName = ({party}: L4SignatureNameProps) => {
	const signingNameConcept = useConceptStatus(CollaboratingPhysicianSignatureNameConcept.cid)
	const cpValue = getConceptStatusValue(signingNameConcept)
	const exp = useFormSelector(selectExport)
	let label: string = ''
	let value: string = ''
	switch(party) {
		case 'patient':
			label = 'Patient'
			value = exp?.Form.Member.MemberName ?? 'Unknown Patient'
			break
		case 'evaluator':
			label = 'Completed By'
			value = exp?.Form.Encounter.ClinicianNameDegree ?? 'Unknown Evaluator'
			break
		case 'collaborator':
			label = 'Collaborating Clinician'
			value = String(cpValue ?? '') || (exp?.Form.Encounter.AccessingClinicianNameDegree ?? 'Unknown Collaborator')
			break
	}
	
	return (
		<L1InputLabel label={label} value={value} />
	)
}

export default L4SignatureName
